// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: relative;
  background-color: #131313;
  box-shadow: var(--container-shadow);
  border-radius: 10px;
  padding: 16px;
  transition: width 0.3s ease-in-out;
  width: 240px;
  min-height: 100vh;
}
@media (max-width: 1200px) {
  .sidebar {
    width: 100%;
    min-height: auto;
  }
}
.sidebar__header {
  display: flex;
  justify-content: center;
  padding: 20px 0;
  color: var(--accent-color);
}
.sidebar__wrapper {
  padding: 0px;
}
@media (max-width: 1200px) {
  .sidebar__list {
    display: flex;
  }
}
@media (max-width: 768px) {
  .sidebar__list {
    flex-wrap: wrap;
  }
}
.sidebar__list-item {
  color: var(--accent-color);
  display: flex;
  align-items: center;
  transition: background 0.2s ease-in;
  opacity: 1;
  padding: 8px 0;
  position: relative;
  width: 100%;
}
@media (max-width: 768px) {
  .sidebar__list-item {
    display: flex;
  }
}
.sidebar__list-item a {
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  color: #fff;
}
.sidebar__list-item a.active {
  background: var(--primary-color);
}
.sidebar__list-item a svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
}
.sidebar__list-item a:hover {
  background: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/Sidebar/Sidebar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,YAAA;EACA,iBAAA;AADF;AAGE;EAVF;IAWI,WAAA;IACA,gBAAA;EAAF;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,0BCnBM;ADoBV;AACE;EACE,YAAA;AACJ;AAEI;EADF;IAEI,aAAA;EACJ;AACF;AAAI;EAJF;IAKI,eAAA;EAGJ;AACF;AADE;EACE,0BCjCM;EDkCN,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AAGJ;AAFI;EATF;IAUI,aAAA;EAKJ;AACF;AAJI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;AAMN;AALM;EACE,gCCxDD;AD+DP;AALM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAOR;AAJM;EACE,gCCnED;ADyEP","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.sidebar{\r\n  position:relative;\r\n  background-color: #131313;\r\n  box-shadow: var(--container-shadow);\r\n  border-radius: 10px;\r\n  padding: 16px;\r\n  transition: width 0.3s ease-in-out;\r\n  width: 240px;\r\n  min-height: 100vh;\r\n // height: 100%;\r\n  @media (max-width:1200px){\r\n    width: 100%;\r\n    min-height: auto;\r\n  }\r\n  &__header{\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 20px 0;\r\n    color: $accent;\r\n  }\r\n  &__wrapper{\r\n    padding: 0px;\r\n  }\r\n  &__list{\r\n    @media (max-width:1200px){\r\n      display: flex;\r\n    }\r\n    @media (max-width:768px){\r\n      flex-wrap: wrap;\r\n    }\r\n  }\r\n  &__list-item{\r\n    color: $accent;\r\n    display: flex;\r\n    align-items: center;\r\n    transition: background 0.2s ease-in;\r\n    opacity: 1;\r\n    padding: 8px 0;\r\n    position: relative;\r\n    width: 100%;\r\n    @media (max-width:768px){\r\n      display: flex;\r\n    }\r\n    a{\r\n      width: 100%;\r\n      padding: 20px;\r\n      border-radius: 4px;\r\n      display: flex;\r\n      align-items: center;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      text-decoration: none;\r\n      color:#fff;\r\n      &.active{\r\n        background: $main;\r\n      }\r\n      svg{\r\n        width: 20px;\r\n        height: 20px;\r\n        display: inline-block;\r\n        margin-right: 8px;\r\n        flex-shrink: 0;\r\n       // fill:#fff;\r\n      }\r\n      &:hover{\r\n        background: $main;\r\n      }\r\n    }\r\n  }\r\n}","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
